module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_CN/address/city.js
// module id = 2200
// module chunks = 0